import { NgModule } from '@angular/core';
import { ModuleWithProviders } from '@angular/compiler/src/core';

import { IhmConfigurationService } from '../ihm-configuration.service';
import { IHM_CONFIG } from '../ihm-configuration.model';
import { IhmConfigurationTestingService } from './ihm-configuration-testing.service';

@NgModule()
export class IhmConfigurationTestingModule {
  public static initConfig(configuration: any): ModuleWithProviders {
    return {
      ngModule: IhmConfigurationTestingModule,
      providers: [
        { provide: IhmConfigurationService, useClass: IhmConfigurationTestingService },
        { provide: IHM_CONFIG, useValue: configuration }
      ]
    };
  }
}
